import { render, staticRenderFns } from "./cModalCirugia.vue?vue&type=template&id=491085fd"
import script from "./cModalCirugia.vue?vue&type=script&lang=js"
export * from "./cModalCirugia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports